import * as THREE from 'three'
import {useThree} from '@react-three/fiber'
import {Outlines, useGLTF} from '@react-three/drei'
import {useCallback, useMemo, useRef, useState,} from 'react'
import {SelectionHover} from './SelectionHover.jsx'
import {useAppStore} from '../stores/store.js'
import {INFO_PANEL_DATA, TROPHY_BOX_PROPS} from '../utils/constants.jsx'
import {usePulsatingOutline} from '../hooks/usePulsatingOutline.jsx'

export function TrophyModel({...props}) {
    const {nodes, materials} = useGLTF('./models/trophy_compressed.glb')
    const trophyRef = useRef(null)
    const [hovered, setHovered] = useState(false)
    const {camera, size} = useThree()

    const outlineThickness = usePulsatingOutline(0.01, 0.03, 2); // Adjust values as needed

    const customTrophyMaterials = useMemo(() => {
        const result = {}
        Object.entries(materials).forEach(([name, originalMaterial]) => {
            result[name] = new THREE.MeshBasicMaterial({
                map: originalMaterial.map,
                color: originalMaterial.color,
            })
        })
        return result
    }, [materials])

    const handleClick = useCallback((event) => {
        event.stopPropagation()

        if (!trophyRef.current || !camera || !size.width || !size.height) {
            console.warn('Click skipped: Missing refs, handlers, or camera/size info.')
            return
        }

        const {focusOnObject, selectObject} = useAppStore.getState()

        // Get World Position
        const worldPos = new THREE.Vector3()
        trophyRef.current.getWorldPosition(worldPos)

        const cameraFocusOffset = new THREE.Vector3(0, 0, -5)
        focusOnObject(worldPos, cameraFocusOffset)
        selectObject(INFO_PANEL_DATA.trophy.id)

    }, [camera, size])

    const handlePointerEnter = useCallback((e) => {
        e.stopPropagation()
        setHovered(true)
        document.body.style.cursor = 'pointer'
    }, [])

    const handlePointerOut = useCallback((e) => {
        e.stopPropagation()
        setHovered(false)
        document.body.style.cursor = 'default'
    }, [])

    return (
        <>
            <group {...props} dispose={null}>
                <mesh name='trophy_purple'
                      geometry={nodes.trophy_1.geometry}
                      material={customTrophyMaterials.trophy_purple}
                >
                    {/*<Outlines thickness={outlineThickness} color='white' screenspace={true}/>*/}
                </mesh>
                <mesh name='trophy_orange'
                      geometry={nodes.trophy_2.geometry}

                      material={customTrophyMaterials.trophy_orange}
                >
                    <Outlines thickness={outlineThickness} color='white' screenspace={true}/>
                </mesh>
                <mesh name='trophy_ribbon'
                      geometry={nodes.trophy_3.geometry}
                      material={customTrophyMaterials.trophy_ribbon}
                >
                    {/*<Outlines thickness={outlineThickness} color='white' screenspace={true}/>*/}
                </mesh>

                <mesh name='trophy_brown'
                      geometry={nodes.trophy_4.geometry}
                      material={customTrophyMaterials.trophy_brown}
                >
                    <Outlines thickness={outlineThickness} color='white' screenspace={true}/>
                </mesh>
                <mesh name='trophy_white'
                      geometry={nodes.trophy_5.geometry}
                      material={customTrophyMaterials.white_shelves}
                >
                    {/*<Outlines thickness={outlineThickness} color='white' screenspace={true}/>*/}
                </mesh>
            </group>
            <mesh
                position={TROPHY_BOX_PROPS.position}
                scale={TROPHY_BOX_PROPS.scale}
                ref={trophyRef}
                onPointerEnter={handlePointerEnter}
                onPointerOut={handlePointerOut}
                onClick={handleClick}
            >
                <boxGeometry/>
                <meshBasicMaterial
                    visible={false}
                    // color='blue'
                    // opacity={0.5}
                    // transparent={true}
                />
            </mesh>
            
            <SelectionHover
                objectRef={trophyRef}
                hovered={hovered}
                cornerSize={0.5}
                padding={0.02}
            />
        </>
    )
}

useGLTF.preload('./models/trophy_compressed.glb')
